import { Flex, Icon } from '@chakra-ui/react';
import { Grid01 } from '@kula-ai/icons/dual-tone/Grid01';
import { List } from '@kula-ai/icons/dual-tone/List';

const defaultToggleList = [
  { label: 'Card view', id: 'card', icon: Grid01 },
  { label: 'Table view', id: 'table', icon: List },
];

interface TableCardToggleProps {
  currentView?: string;
  toggleList?: typeof defaultToggleList;
  filterActions?: (_: { type: string; view: string }) => void;
}

export const TableCardToggle = ({
  currentView,
  toggleList = defaultToggleList,
  filterActions,
}: TableCardToggleProps) => {
  const activeView = toggleList.find((i) => i.id === currentView);

  const handleViewChange = (item: typeof defaultToggleList[0]) => {
    filterActions?.({ type: 'view', view: item?.id });
  };

  return (
    <>
      {toggleList.map((item) => (
        <Flex
          w="1.75em"
          h="1.75em"
          key={item?.id}
          cursor="pointer"
          onClick={() => handleViewChange(item)}
          alignItems="center"
          justifyContent="center"
          borderRadius="6px"
          bgColor={activeView?.id === item?.id && 'ats-tertiary'}
        >
          <Icon as={item?.icon} color="secondary-900" />
        </Flex>
      ))}
    </>
  );
};
